import { IAppState } from '../../../store/appState';
import { Vorschaeden } from '../../../store/reducers/vorschaeden.reducer';

export const selectVorschaeden = (state: IAppState): Vorschaeden => state.vorschaeden;

export const selectVorschaedenUeberschritten = (state: IAppState): boolean => {
  return state.vorschaeden.thhHundVorschaeden > 4;
};
